document.addEventListener('DOMContentLoaded', function() {
    // Znajdź wszystkie inputy radio dla rozmiarów
    const sizeRadios = document.querySelectorAll('.product-form__input input[type="radio"]');
   
    // Usuń domyślny wybór
    sizeRadios.forEach(radio => {
      radio.checked = false;
    });
  
  
    // Nadpisz metodę toggleSubmitButton w product-form
    const productForm = document.querySelector('product-form');
    if (productForm) {
      const originalToggleSubmitButton = productForm.toggleSubmitButton;
      productForm.toggleSubmitButton = function(disable = true, text) {
        const selectedSize = document.querySelector('.product-form__input input[type="radio"]:checked');
        if (selectedSize) {
          this.submitButton.removeAttribute('disabled');
        } else {
          this.submitButton.setAttribute('disabled', 'disabled');
        }
      };
    }
  
  
        // Nasłuchuj na wydarzenie variantChange
    document.addEventListener('variantChange', function(event) {
      const selectedSize = document.querySelector('.product-form__input input[type="radio"]:checked');
      const addToCartButtons = document.querySelectorAll('.product-form__submit');
      const shopPayButton = document.querySelector('.custom-button-shoppay');
     
      if (addToCartButtons) {
        addToCartButtons.forEach(button => {
          const buttonText = button.querySelector('span');
          if (selectedSize) {
            button.disabled = false;
            if (buttonText) {
              buttonText.textContent = buttonText.getAttribute('data-add-to-cart-text') || 'Add to cart';
            }
          } else {
            button.disabled = true;
            if (buttonText) {
              buttonText.textContent = buttonText.getAttribute('data-select-size-text') || 'Select your size';
            }
          }
        });
      }


      if (shopPayButton) {
        shopPayButton.disabled = !selectedSize;
      }
    });
  
  
        // Dodaj nasłuchiwanie na zmiany w wyborze rozmiaru
    sizeRadios.forEach(radio => {
      radio.addEventListener('change', function() {
        const addToCartButtons = document.querySelectorAll('.product-form__submit');
        const shopPayButton = document.querySelector('.custom-button-shoppay');
       
        if (addToCartButtons) {
          addToCartButtons.forEach(button => {
            const buttonText = button.querySelector('span');
            if (this.checked) {
              button.disabled = false;
              if (buttonText) {
                buttonText.textContent = buttonText.getAttribute('data-add-to-cart-text') || 'Add to cart';
              }
            } else {
              button.disabled = true;
              if (buttonText) {
                buttonText.textContent = buttonText.getAttribute('data-select-size-text') || 'Select your size';
              }
            }
          });
        }


        if (shopPayButton) {
          shopPayButton.disabled = !this.checked;
        }
      });
    });
  
  
        // Początkowo wyłącz przyciski dodawania do koszyka
    const addToCartButtons = document.querySelectorAll('.product-form__submit');
    const shopPayButton = document.querySelector('.custom-button-shoppay');
   
    if (addToCartButtons) {
      addToCartButtons.forEach(button => {
        button.disabled = true;
        const buttonText = button.querySelector('span');
        if (buttonText && !buttonText.textContent.includes('unavailable') && !buttonText.textContent.includes('sold_out')) {
          buttonText.textContent = buttonText.getAttribute('data-select-size-text') || 'Select your size';
        }
      });
    }


    if (shopPayButton) {
      shopPayButton.disabled = true;
    }
  });
  